<template>
  <div>
    <AdminLayout>
      <div class="mt-8 max-w-3xl mx-auto grid grid-cols-1 gap-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
        <div class="space-y-6 lg:col-start-1 lg:col-span-2">
          <Card>
            <div class="px-4 py-5 border-b border-gray-200 sm:px-6 flex flex-wrap justify-between">
              <div>
                <h3 class="inline-block text-lg leading-6 font-medium text-gray-900">
                  {{ team.company }}
                </h3>
              </div>
              <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                <RadialProgress style="--size: 2rem; font-size: 0.5rem" :progress="team.setup_progress" />
              </p>
            </div>
            <div class="px-4 py-5 sm:px-6">
              <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Company</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    {{ team.company }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Syndication Status</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    <span
                      v-if="team.status == 'Active'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ team.status }}
                    </span>
                    <span
                      v-else
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      {{ team.status }}
                    </span>
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Email Reply To</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    <a class="text-indigo-600 hover:text-indigo-900" :href="`mailto:${team.email_reply_to}`">{{
                      team.email_reply_to
                    }}</a>
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Stripe Customer Link</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    <a
                      :href="`https://dashboard.stripe.com/customers/${team.stripe_customer_id}`"
                      class="text-indigo-600 hover:text-indigo-900"
                      target="_blank"
                    >
                      Go to Stripe
                    </a>
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Telco Status</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    <span
                      v-if="telco.status == 'active'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ telco.status }}
                    </span>
                    <span
                      v-else
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      {{ telco.status }}
                    </span>
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Assigned Phone Number</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    {{ telco.telnyx_phone_number }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Bulk Messaging</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    <span
                      v-if="team.bulk_messaging_enabled"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      active
                    </span>
                    <span
                      v-else
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      inactive
                    </span>
                  </dd>
                </div>
              </dl>
            </div>
          </Card>
          <Card class="mt-6">
            <div class="px-4 py-6 sm:px-6">
              <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">$ Spent</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    {{ team.stripe_total_spend }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">$ MRR</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    {{ team.stripe_total_mrr }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500"># of Candidates All Time</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    {{ team.number_of_candidates_all_time }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">
                    # of Unlicensed with Coursework Started Candidates All Time
                  </dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    {{ team.number_of_coursework_started_candidates_all_time }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500"># of Unlicensed Candidates All Time</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    {{ team.number_of_unlicensed_candidates_all_time }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500"># of Agents</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    {{ team.number_of_agents }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500"># of Candidates Last 30 Days</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    {{ team.number_of_candidates_last_30_days }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500"># of Candidates Last 90 Days</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    {{ team.number_of_candidates_last_90_days }}
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500"># of Pipeline Reviews Last 30 Days</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    {{ team.number_of_pipeline_reviews_last_30_days }}
                  </dd>
                </div>
              </dl>
            </div>
          </Card>
        </div>

        <div>
          <Card>
            <div class="px-4 py-5 sm:px-6">
              <h2 id="users-title" class="text-lg font-medium text-gray-900">Actions</h2>
            </div>
            <div class="px-4 py-6 sm:px-6">
              <ToggleInput
                label="Active Customer"
                :model-value="team.active_customer"
                @update:model-value="value => updateTeam('active_customer', value)"
              />
              <ToggleInput
                class="mt-4"
                label="Job Syndication"
                :model-value="team.syndication_status"
                @update:model-value="value => updateTeam('status', value)"
              />
            </div>
          </Card>
          <Card class="mt-6">
            <div class="px-4 py-5 sm:px-6">
              <h2 id="users-title" class="text-lg font-medium text-gray-900">Integrations</h2>
            </div>
            <div class="px-4 py-6 sm:px-6">
              <dl class="grid grid-cols-1 gap-x-4 gap-y-8">
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Indeed</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    <span
                      v-if="team.syndication_status"
                      class="capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      Active
                    </span>
                    <span
                      v-else
                      class="capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      Inactive
                    </span>
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">ZipRecruiter</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    <span
                      v-if="team.syndication_status"
                      class="capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      Active
                    </span>
                    <span
                      v-else
                      class="capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      Inactive
                    </span>
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Monster</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    <span
                      v-if="team.syndication_status"
                      class="capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      Active
                    </span>
                    <span
                      v-else
                      class="capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      Inactive
                    </span>
                  </dd>
                </div>
                <div class="sm:col-span-1">
                  <dt class="text-sm leading-5 font-medium text-gray-500">Meta</dt>
                  <dd class="mt-1 text-sm leading-5 text-gray-900">
                    <div v-if="facebookIntegration">
                      <div v-if="facebookIntegration.status == 'active'">
                        <span
                          class="capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                        >
                          {{ facebookIntegration.status }}
                        </span>
                        <span
                          class="capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                        >
                          {{ facebookIntegration.form_id }}
                        </span>
                      </div>
                      <div v-else>
                        <span
                          class="capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                        >
                          {{ facebookIntegration.status }}
                        </span>
                        <span
                          class="capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                        >
                          {{ facebookIntegration.error }}
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <span
                        class="capitalize px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                      >
                        Inactive
                      </span>
                    </div>
                  </dd>
                </div>
              </dl>
            </div>
          </Card>
        </div>
      </div>

      <Card class="mt-6">
        <div class="px-4 py-5 sm:px-6">
          <h2 id="users-title" class="text-lg font-medium text-gray-900">Users</h2>
        </div>
        <div class="px-4 py-6 sm:px-6">
          <DataTable :columns="dtColumns" :rows="rows" :sort="sort">
            <template #td-status="slotProps">
              <span
                v-if="slotProps.row"
                class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                :class="slotProps.row.status == `inactive` ? `bg-red-100 text-red-800` : `bg-green-100 text-green-800`"
              >
                {{ slotProps.row.status }}
              </span>
            </template>
            <template #td-action="slotProps">
              <TButton v-if="slotProps.row.status == `active`" @click="impersonateUser(slotProps.row)">
                Impersonate
              </TButton>
              <TButton v-if="slotProps.row.status == `active`" @click="scheduleCheckin(slotProps.row)">
                Schedule Check-in
              </TButton>
            </template>
          </DataTable>
        </div>
      </Card>

      <TeamAdvertisingHistory class="mt-6" :history="budgetHistory" />
    </AdminLayout>
  </div>
</template>

<script>
import AdminLayout from '../AdminLayout/index.vue';
import Card from '../Card/index.vue';
import DataTable from '../shared/DataTable/index.vue';
import { formatCurrencyToHuman, formatStandardDateTime } from '../../utilities/format.ts';
import RadialProgress from '../shared/RadialProgress.vue';
import TeamAdvertisingHistory from './TeamAdvertisingHistory.vue';

export default {
  components: {
    AdminLayout,
    Card,
    DataTable,
    RadialProgress,
    TeamAdvertisingHistory,
  },
  data() {
    return {
      team: {},
      teamMembers: [],
      budgetHistory: [],
      facebookIntegration: null,
      loaded: false,
      telco: {},
    };
  },
  computed: {
    dtColumns() {
      return [
        {
          label: 'Mobile Phone Number',
          key: 'mobile_phone_number',
          sortable: false,
        },
        {
          label: 'Email',
          key: 'email',
          sortable: false,
        },
        {
          label: 'Status',
          key: 'status',
          sortable: false,
        },
        {
          label: 'Created',
          key: 'created_at',
          formatter: formatStandardDateTime,
          sortable: false,
        },
        {
          label: 'Action',
          key: 'action',
          sortable: false,
        },
      ];
    },
    rows() {
      return this.teamMembers;
    },
    sort() {
      return {
        key: 'created_at',
        order: 'desc',
      };
    },
  },
  mounted() {
    this.getTeam();
    this.getAdvertising();
  },
  methods: {
    getReload() {
      this.getTeam();
    },
    getTeam() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/admin/teams/${self.$route.params.id}`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          data.record.syndication_status = data.record.status == 'Active' ? true : false;
          self.team = data.record;
          self.team.stripe_total_spend = formatCurrencyToHuman(self.team.stripe_total_spend / 100);
          self.team.stripe_total_mrr = formatCurrencyToHuman(self.team.stripe_total_mrr / 100);
          self.teamMembers = data.users;
          self.telco = data.telco;
          self.facebookIntegration = data.facebook_advertising_configuration;
          self.loaded = true;
        });
    },
    getAdvertising() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/api/admin/monthly_marketing_budgets?id=${self.$route.params.id}`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          if (data.active_budget != null) {
            self.indeed = data.active_budget.indeed_spend;
            self.zipRecruiter = data.active_budget.zip_spend;
            self.monster = data.active_budget.monster_spend;
            self.meta = data.active_budget.meta_spend;
          }
          for (let budget of data.records) {
            self.budgetHistory.push({
              start_date: budget.start_date,
              end_date: budget.end_date,
              indeed_spend: budget.indeed_spend,
              zip_spend: budget.zip_spend,
              monster_spend: budget.monster_spend,
              meta_spend: budget.meta_spend,
              total_spend: budget.indeed_spend + budget.zip_spend + budget.monster_spend + budget.meta_spend,
              cost_per_candidate: budget.cost_per_candidate,
              number_of_candidates: budget.number_of_candidates,
              cost_per_candidate_indeed: budget.cost_per_candidate_indeed,
              number_of_candidates_indeed: budget.number_of_candidates_indeed,
              cost_per_candidate_zip: budget.cost_per_candidate_zip,
              number_of_candidates_zip: budget.number_of_candidates_zip,
              cost_per_candidate_monster: budget.cost_per_candidate_monster,
              number_of_candidates_monster: budget.number_of_candidates_monster,
              cost_per_candidate_meta: budget.cost_per_candidate_meta,
              number_of_candidates_meta: budget.number_of_candidates_meta,
            });
          }
        });
    },
    impersonateUser(record) {
      window.location.href = `/api/admin/teams/${record.id}/impersonate_user`;
    },
    scheduleCheckin(record) {
      window.location.href = `/interview/${this.team.slug}?event_type=humaniz_checkin&humaniz_checkin_user_id=${record.id}`;
    },
    updateTeam(field, value) {
      const self = this;
      let body = field == 'status' ? { status: value ? 'Active' : 'Inactive' } : { active_customer: value };
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/admin/teams/${self.$route.params.id}`, {
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Customer updated',
              alertDescription: 'Your customer was successfully updated.  Use the button below to dismiss this alert.',
            });
            self.getTeam();
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Customer update edit error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
